import PropTypes from 'prop-types';

import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined';
import RemoveOutlinedIcon from '@mui/icons-material/RemoveOutlined';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const CheckmarkOrXComponent = ({ value }) => {
  const theme = useTheme();
  const green = theme.palette.success.main;
  const red = theme.palette.secondary.main;
  return (
    <Box display="flex" justifyContent="center">
      {value ? (
        <DoneOutlinedIcon style={{ color: green }} />
      ) : (
        <RemoveOutlinedIcon style={{ color: red }} />
      )}
    </Box>
  );
};

CheckmarkOrXComponent.propTypes = {
  value: PropTypes.bool,
};

export default CheckmarkOrXComponent;
